import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, Lock, User, Phone, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mocktail-hub-6/artifacts/yiexn6qe_Simple%20Modern%20Minimalist%20Circle%20Design%20Studio%20Logo.png";

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Mot de passe: 6 caracteres minimum'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/register', form);
      login(data.token, data.user);
      toast.success('Compte cree avec succes !');
      navigate('/events', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8 slide-up">
          <Link to="/"><img src={LOGO_URL} alt="RSX" className="w-16 h-16 rounded-full mx-auto mb-4" /></Link>
          <h1 className="text-2xl font-light tracking-tight" style={{ fontFamily: 'Outfit' }}>Creer un compte</h1>
          <p className="text-sm text-[#A1A1AA] mt-1">Rejoignez RSX Concept</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 slide-up stagger-1">
          <div>
            <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Nom complet</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
              <Input value={form.name} onChange={set('name')} required data-testid="register-name"
                placeholder="Votre nom" className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Email</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
              <Input type="email" value={form.email} onChange={set('email')} required data-testid="register-email"
                placeholder="vous@email.com" className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Telephone</Label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
              <Input value={form.phone} onChange={set('phone')} data-testid="register-phone"
                placeholder="+33 ..." className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
              <Input type="password" value={form.password} onChange={set('password')} required data-testid="register-password"
                placeholder="6 caracteres min." className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit-btn"
            className="w-full bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full h-11 text-sm font-semibold">
            {loading ? <div className="spin-gold w-5 h-5" /> : <><ArrowRight className="w-4 h-4 mr-2" /> Creer mon compte</>}
          </Button>
          <p className="text-center text-sm text-[#A1A1AA]">
            Deja inscrit ?{' '}
            <Link to="/login" className="text-[#D4AF37] hover:text-[#F9E5C0]" data-testid="login-link">Se connecter</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
